import * as React from "react";
import { extent } from "d3";
import { MiniLineChart } from "./MiniLineChart";
import { MiniBarChart } from "./MiniBarChart";
export class MiniChartPanel extends React.Component {
    render() {
        const { locations, metadata, data, getTimeValue, availableDimensions, selectedDimension } = this.props;
        const [min, max] = extent(data, getTimeValue);
        if (min === undefined || max === undefined) {
            // Oh no!
            return null;
        }
        const miniChartType = min < max ? "line" : "bar";
        const MiniChart = min < max ? MiniLineChart : MiniBarChart;
        const margins = {
            top: 10,
            right: 10,
            bottom: 40,
            left: 10
        };
        return (<MiniChart {...this.props} margins={margins}/>);
    }
}



// WEBPACK FOOTER //
// ./src/detail/MiniChartPanel.tsx